import { Layout } from "@/modules/DashboardTemplate/models/Layout";
import { Vue } from "vue-property-decorator";

export function handleResizeMove(
  event: Interact.ResizeEvent,
  el: HTMLElement,
  layout: Layout,
  margin: number,
  allowAutoGrow: boolean,
  limits?: { maxX?: number; maxY?: number }
) {
  const parent = el.parentElement as HTMLElement;
  if (!parent) return;

  const parentRect = parent.getBoundingClientRect();

  const dynamicWrapper = el.querySelector(
    ".content-wrapper"
  ) as HTMLElement | null;
  const limitElement = dynamicWrapper?.querySelector(
    ".background-limit"
  ) as HTMLElement | null;

  let minW = limits?.maxX ?? 50; // Reduje 250 a 50 para dar más flexibilidad, ajusta según tu UX
  let minH = limits?.maxY ?? 50;

  if (limitElement && dynamicWrapper && limitElement.offsetParent !== null) {
    const wrapperRect = dynamicWrapper.getBoundingClientRect();
    const limitRect = limitElement.getBoundingClientRect();
    const relativeX = limitRect.left - wrapperRect.left;
    const relativeY = limitRect.top - wrapperRect.top;
    minW = Math.max(minW, relativeX + limitRect.width + margin);
    minH = Math.max(minH, relativeY + limitRect.height + margin);
  }

  const maxParentW = parentRect.width;
  const maxAvailableWidth = maxParentW - layout.x;

  let newWidth = Math.max(minW, event.rect.width);
  let newHeight = Math.max(minH, event.rect.height);

  if (newWidth > maxAvailableWidth) {
    newWidth = maxAvailableWidth;
  }

  if (!allowAutoGrow) {
    const maxParentH = parentRect.height;
    const maxAvailableHeight = maxParentH - layout.y;
    if (newHeight > maxAvailableHeight) {
      newHeight = maxAvailableHeight;
    }
  }

  Vue.set(layout, "width", newWidth);
  Vue.set(layout, "height", newHeight);

  requestAnimationFrame(() => {
    el.style.width = `${newWidth}px`;
    el.style.height = `${newHeight}px`;
  });
}
